import InvestmentAccreditationUpdateModal from "./InvestmentAccreditationUpdateModal";

export default InvestmentAccreditationUpdateModal;
